export const scrollToContent: VoidFunction = () => {
  document.querySelector('#content')?.scrollIntoView({ behavior: 'smooth' })
}
